import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { IFullSearchResult } from '$models';
import { FacetList, getFilterParamsFromResult, getUrlKey } from '../../helpers';
import { http } from '$lib/http';
import { SearchContentTypes } from '~/modules/search';

export const useFilterResultsMeta = (
    filterId?: string,
    searchTerm = '*',
    searchMode: SearchContentTypes = SearchContentTypes.All,
    facetParams: FacetList = {},
    pId?: string,
    pageId?: string,
    sId?: string,
    initialData?: IFullSearchResult
) => {
    const fetchData: () => Promise<IFullSearchResult> = async () => {
        const t = await http(getUrlKey(0, searchTerm, searchMode, filterId, facetParams, 0, pId, pageId, sId));

        return (await t.json()) as IFullSearchResult;
    };

    const { data, error, isFetching } = useQuery<IFullSearchResult, Error>(
        getUrlKey(0, searchTerm, searchMode, filterId, facetParams, 0, pId, pageId, sId),
        fetchData,
        { initialData: initialData, keepPreviousData: true }
    );

    const { totalResults, loading, facets, activeFacets } = useMemo(() => {
        const filterResult = data?.products?.filterResult;

        const activeFacets = getFilterParamsFromResult(filterResult);

        const facets = filterResult?.facets?.map((f) => {
            return {
                ...f,
                isSelected: !!f.facetResults?.some((fr) => fr.isSelected) || f.isSelected,
            };
        });

        return {
            totalResults: filterResult?.totalDocumentsFound,
            loading: !filterResult && isFetching && !error,
            facets,
            activeFacets,
        };
    }, [data, error, isFetching]);

    return {
        totalResults,
        loading,
        facets,
        activeFacets,
    };
};
